// import { useTheme } from "@mui/material/styles";
import { useMaterialReactTable } from "material-react-table";
 
 
export const CustomTableFunction = ({columns, data, tableProperties}) => {
    // const theme = useTheme();
    const table = useMaterialReactTable({
        columns,
        data: data || [], //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        ...tableProperties,
        enableSorting: true,
        enableDensityToggle: false,
        positionToolbarAlertBanner: 'none',
         localization:{
          columnActions:"Column Filters",
         },
        muiTableBodyCellProps: ({ column }) => ({
            //conditionally style pinned columns
            align: 'left',
            sx: {
              fontSize: '0.75rem',
              padding: '8px',
            //   backgroundColor: theme.palette.background.paper
            },
          }), muiTableHeadCellProps: {
            align: 'left',
            sx: {
              fontSize: '11px',
              verticalAlign: 'bottom',
              justifyContent: 'spaceBetween',
              // padding: '0.5rem 0.6rem 0.5rem 0.1rem',
              padding:"1rem",
              backgroundColor:"#D9F6FA",
              color: "#fff",
               fontWeight: 500,
              '& .MuiCollapse-root .MuiFormControl-root': {
            minWidth: 0,
            '& .MuiInputAdornment-root .MuiButtonBase-root':{
                marginRight: '0px'
            }
          },
          '& .Mui-TableHeadCell-Content':{
              justifyContent: 'space-between',
            }
     
            },
          },
       
      });
 
     
   
    return table;
}
 